import { CloudCustomerAddress } from "@omni/types/api/customer/cloud/address.model";
import { useEffect } from "react";
import { useSelector } from "react-redux";

import { AddressValidationProvider } from "@/components/Address/AddressValidation/context/addressValidation.context";
import { useThunkDispatch } from "@/redux/dispatcher";
import * as AddressModule from "@/redux/modules/api/data/address/address.module";
import * as AddressBookModule from "@/redux/modules/api/data/addressbook/addressbook.module";
import * as AddressBookSelectors from "@/redux/modules/api/data/addressbook/addressbook.selectors";

import AddressBook from "./profileAddressBook.component";

const ProfileAddressBook = () => {
    const isLoadingAddresses = useSelector(AddressBookSelectors.isLoading);
    const addressBookError = useSelector(AddressBookSelectors.getErrors);
    const addresses = useSelector(AddressBookSelectors.getAddresses);

    const dispatch = useThunkDispatch();

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        dispatch(AddressBookModule.load());
    }, []);

    const onUpdateDefaultBilling = async (address: CloudCustomerAddress) => {
        await dispatch(AddressModule.updateDefaultBilling(address));
    };

    const onUpdateDefaultDelivery = async (address: CloudCustomerAddress) => {
        await dispatch(AddressModule.updateDefaultDelivery(address));
    };

    return (
        <AddressValidationProvider>
            <AddressBook
                error={addressBookError}
                loading={isLoadingAddresses}
                addresses={addresses || []}
                updateDefaultBilling={onUpdateDefaultBilling}
                updateDefaultDelivery={onUpdateDefaultDelivery}
            />
        </AddressValidationProvider>
    );
};

export { ProfileAddressBook };
